// src/hooks/useMediaQuery.ts
import { useState, useEffect } from 'react';

/**
 * A hook that returns true if the media query matches, false otherwise.
 */
export function useMediaQuery(query: string): boolean {
  const [ matches, setMatches ] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);

    // Initial check
    setMatches(media.matches);

    // Subscribe
    media.addEventListener('change', listener);

    return () => media.removeEventListener('change', listener);
  }, [ query ]);

  return matches;
}
